// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Color, SolidBrush } from "../../../Commons/Graphics.js";
import { DataCacheTool } from "../DataCacheTool.js";
import { DynProperty } from "../../DynProperty.js";

export let FillableDataCacheTool = function ()
{
    DataCacheTool.apply(this);

    this.fill = false;
    this.fillColor = null;
    this.fillBrush = null;

    this.InitBlock();
};

FillableDataCacheTool.prototype = Object.create(DataCacheTool.prototype);

Object.defineProperty(FillableDataCacheTool.prototype, 'FillColor', {
    get: function () { return this.fillColor; },
    set: function (value)
    {
        if (this.fillColor === value)
            return;

        this.fillColor = value;
        this.fillBrush = new SolidBrush(this.fillColor);
    }
});

Object.defineProperty(FillableDataCacheTool.prototype, 'FillBrush', {
    get: function () { return this.fillBrush; },
});

FillableDataCacheTool.prototype.InitBlock = function ()
{
    DataCacheTool.prototype.InitBlock.apply(this);

    this.fill = true;
    this.FillColor = Color.FromArgb(this.colorAlpha, this.Color);
};

//#region ICaller

FillableDataCacheTool.prototype.Properties = function ()
{
    var props = DataCacheTool.prototype.Properties.apply(this);

    props.push(new DynProperty("chart.tools.back", this.fill, DynProperty.BOOLEAN, DynProperty.VISUAL_GROUP));
    props.push(new DynProperty("chart.tools.backcolor", this.fillColor, DynProperty.COLOR, DynProperty.VISUAL_GROUP));

    return props;
};

FillableDataCacheTool.prototype.callBack = function (properties)
{
    DataCacheTool.prototype.callBack.call(this, properties);

    var prop = DynProperty.getPropertyByName(properties, "chart.tools.back");
    if (prop) this.fill = prop.value;

    prop = DynProperty.getPropertyByName(properties, "chart.tools.backcolor");
    if (prop) this.FillColor = prop.value;
};

//#endregion